import React, {useEffect, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {Redirect, useLocation} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_intesys/layout";
import {actions} from "../_redux/authRedux";

export default function Logged() {
    const [redirectToError, setRedirectToError] = useState(false);
    const [redirectTo, setRedirectTo] = useState("/");

    const { hasUser} = useSelector(
        (state) => ({
            hasUser: Boolean(state.auth.user),
        }),
        shallowEqual
    );

    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.has('redirect')) {
            const redirect = searchParams.get('redirect');
            setRedirectTo(redirect);
        }
        dispatch(actions.userLogged());
    }, [location, dispatch]);


    useEffect(() => {
        const timer = setTimeout(() => {
            setRedirectToError(true);
        }, 10000);
        return () => clearTimeout(timer);
    }, []);
    return redirectToError ?
        <Redirect to="/error/error-v1"/> :
        (
            (hasUser) ?
                <Redirect to={redirectTo}/>
                :
                <LayoutSplashScreen/>
        );
}
